import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { BidderIndividualProfileForm } from '@/components/auth/bidder-individual-form';
import { BidderRoleGate } from '@/components/auth/bidder-role-gate';
import { PageHeader } from '@/components/dashboard/page-header';

export const Route = createFileRoute('/_app/profile/bidder/individual')({
  component: BidderIndividualProfilePage,
});

function BidderIndividualProfilePage(): React.ReactElement {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Profil Bidder Individuel"
        subtitle="Renseignez votre identité, vos compétences, vos langues (CECRL) et votre identifiant légal (SIRET FR, TVA UE, EIN US, etc.)."
      />
      <BidderRoleGate bidderType="INDIVIDUAL">
        <section className="border-border bg-card rounded-2xl border p-6 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)] md:p-8">
          <BidderIndividualProfileForm />
        </section>
      </BidderRoleGate>
    </div>
  );
}
